import { MessageEnhancement } from '../common/custom-hooks/useProjectEnhancement';

interface FeedbackMessageProps {
  message: MessageEnhancement;
  className?: string;
  style?: React.CSSProperties;
  close?: () => void;
}

const FeedbackMessage: React.FC<FeedbackMessageProps> = ({ message, className = '', style, close }) => {
  if (!message) return null;

  return (
    <div key={message.type} className={`${message.className} ${className}`} style={{ width: '100%', ...style }}>
      {message.value}

      {close && (
        <button onClick={close} className={`message-animate-button-close ${className}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default FeedbackMessage;
